import { SelectiveExceptionHandler } from './selective-exception-handler'

export class LocalLoggerExceptionHandler extends SelectiveExceptionHandler {

  public handleError(exception: any, stackTrace?: any, reason?: string) {
    console.error(exception)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/helpers/exception-handlers/local-logger-exception-handler.ts